import { PureComponent } from 'react'
import styled from 'glamorous'
import { $ } from 'utils'
import { Icon } from 'components'
import { noop } from 'lodash'

const Header = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '20px',
}, 'headerRow')

const Label = styled.div({
  display: 'inline-flex',
  flex: 1,
  whiteSpace: 'nowrap',
  justifyContent: 'flex-start',
  alignItems: 'center',
  fontSize: '19px',
  fontWeight: '700',
}, ({ clickable }) => clickable && ({
  cursor: 'pointer'
}), 'label')

const Count = styled.div({
  display: 'inline-flex',
  color: 'var(--lightGrey)',
  marginLeft: 7,
  fontSize: 16,
})

const Actions = styled.div({
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'flex-start',
  alignItems: 'center',
  alignSelf: 'flex-start',
  marginLeft: 'auto',
  '&>*:not(:last-child)': {
    marginRight: 10
  }
}, 'actions')

export default class HeaderRow extends PureComponent {

  formatCount = (count) => {
    return ('0' + count.toString()).slice(-2)
  }

  render() {
    const children = this.props.children
    const { label, count, onLabelClick, clickable, withArrow = false } = this.props
    return (
      $(Header,
        $(Label, { onClick: clickable ? onLabelClick : noop, clickable, },
          withArrow &&
            $(Icon, {
              type: 'arrowLeft', 
              color: 'var(--violet)', 
              style: {
                marginLeft: '-10px',
                marginTop: '-2px'
              }
            }),
          label,
          count >= 0 && $(Count, `(${count})`)
        ),
        $(Actions,
          children
        )
      )
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/HeaderRow.js